import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntlD60 } from './pages'

type TIdToPageMapIntlD60 = Record<PageIdIntlD60, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_D60: TIdToPageMapIntlD60 = {
  [PageIdIntlD60.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/offer/OfferPage'),
  },
  [PageIdIntlD60.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/payment/PaymentPage'),
  },
  [PageIdIntlD60.CHECKOUT]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/checkout/CheckoutPage').then((m) => ({
        default: m.CheckoutPage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/checkout/CheckoutPage'),
  },
  [PageIdIntlD60.UPSELL]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/upsell/UpsellPage').then((m) => ({
        default: m.UpsellPage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/upsell/UpsellPage'),
  },
  [PageIdIntlD60.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/account/AccountNove8'),
  },
  [PageIdIntlD60.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/name/NamePage'),
  },
  [PageIdIntlD60.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/certificate/CertificatePage').then(
        (m) => ({
          default: m.CertificatePage,
        }),
      ),
    ),
    preload: () => import('cohorts/intl_d60/pages/certificate/CertificatePage'),
  },
  [PageIdIntlD60.LEARNWORLDS_REDIRECT]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/learnWorldsRedirect/LearnWorldsRedirectPage').then(
        (m) => ({
          default: m.LearnWorldsRedirectPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_d60/pages/learnWorldsRedirect/LearnWorldsRedirectPage'),
  },
  [PageIdIntlD60.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_d60/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_d60/pages/report/ReportPage'),
  },
}
